import BaseClient from '@/app/model/api/response/baseApiClient'

class ServiceFunctionEditApi extends BaseClient {
  public doServiceFunctionEdit (bodyData: {[key:string]: any}) {
    const path:string = '/v1/service-functions'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new ServiceFunctionEditApi()
